<!--
/**
 * DjFrequencyLimitTab.vue - 接通限频 Tab 组件
 *
 * 【功能说明】
 * 本组件是迪加(DJ)虚拟商品管理系统的接通限频管理页面，
 * 用于管理号码的拨打频率限制。可以为指定号码设置每日最大接通次数，
 * 防止号码被过度使用，也可以删除已设置的限频规则。
 *
 * 【主要功能】
 * 1. 限频记录查询 - 按号码、状态、类型等条件查询限频记录
 * 2. 导入号码设置限频 - 手动输入号码并设置接通频次
 * 3. 批量删除限频 - 批量删除指定号码的限频规则
 *
 * 【权限要求】
 * - 所有用户：可执行所有操作
 -->
<template>
  <div>
    <!-- ========== 搜索区域 ========== -->
    <div class="handle-box">
      <!-- 号码输入框 -->
      <el-input size="small" v-model="query15.phone" clearable placeholder="请输入号码" class="mr10"
                style="width: 180px;"></el-input>
      <!-- 状态筛选（全部/成功/失败） -->
      <el-select size="small" style="width: 180px" v-model="query15.sus" filterable clearable
                 placeholder="状态" class="handle-select mr10">
        <el-option v-for="item in susList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 类型筛选（全部/添加/删除） -->
      <el-select size="small" style="width: 180px" v-model="query15.type" filterable clearable
                 placeholder="类型" class="handle-select mr10">
        <el-option v-for="item in typeList" :key="item.value" :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
      <!-- 查询按钮 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
                 @click="getdeptParam">查询
      </el-button>
      <!-- 导入号码按钮 - 打开导入弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-upload"
                 @click="getImport">导入号码
      </el-button>
      <!-- 批量删除按钮 - 打开批量删除弹窗 -->
      <el-button size="small" type="primary" :class="[theme]" icon="el-icon-delete"
                 @click="showBatchDeletefrequency">批量删除
      </el-button>
    </div>

    <!-- ========== 限频记录表格 ========== -->
    <el-table :data="tableData15" border class="table" ref="multipleTable" max-height="600"
              header-cell-class-name="table-header" :row-style="{ height: '20px' }"
              :cell-style="{ padding: '6px' }" :header-cell-style="{ 'text-align': 'center' }" stripe
              @selection-change="handleSelectionChange" v-loading="loading">
      <!-- 多选列 -->
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <!-- 手机号码 -->
      <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
      <!-- 接通限频次数 -->
      <el-table-column prop="callNum" label="接通限频" align="center"></el-table-column>
      <!-- 类型（添加=绿色标签，删除=红色标签） -->
      <el-table-column prop="type" label="类型" align="center">
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.type=='AM'" size="small">添加</el-tag>
          <el-tag type="danger" v-if="scope.row.type=='D'" size="small">删除</el-tag>
        </template>
      </el-table-column>
      <!-- 状态（成功=绿色，失败=红色） -->
      <el-table-column prop="sus" label="状态" align="center">
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.sus" size="small">成功</el-tag>
          <el-tag type="danger" v-else size="small">失败</el-tag>
        </template>
      </el-table-column>
      <!-- 错误原因 -->
      <el-table-column prop="errMsg" label="错误原因" align="center" show-overflow-tooltip></el-table-column>
      <!-- 时间 -->
      <el-table-column prop="createdAt" label="时间" align="center"></el-table-column>
      <!-- 操作人 -->
      <el-table-column prop="operator" label="操作人" align="center"></el-table-column>
    </el-table>

    <!-- ========== 分页器 ========== -->
    <div class="pagination">
      <el-pagination background layout="total, sizes, prev, pager, next, jumper"
                     :current-page="query15.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
                     :page-size="query15.pageSize" :total="pageTotal15" @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
    </div>

    <!-- ========== 导入号码/批量删除弹窗 ========== -->
    <!-- 根据 deletefrequencyLimitDowm 的值决定显示导入还是删除功能 -->
    <el-dialog title="导入号码" v-model="frequencyLimitVisible" width="520px" @close="closefrequencyLimitDialog">
      <el-form label-width="120px" :model="frequencyLimitForm" ref="frequencyLimitForm">
        <!-- 频次输入（仅导入模式显示） -->
        <el-form-item label="频次" v-if="deletefrequencyLimitDowm">
          <el-input size="small" placeholder="请输入限频次数" v-model="frequencyLimitForm.callNum" filterable
                    clearable></el-input>
        </el-form-item>
        <!-- 号码输入 -->
        <el-form-item label="号码">
          <el-input size="small" type="textarea" :rows="5" placeholder="一行一个号码"
                    v-model="frequencyLimitForm.phones"></el-input>
        </el-form-item>
        <el-form-item class="dis-end">
          <el-button size="small" @click="closefrequencyLimitDialog">取消</el-button>
          <!-- 导入模式：确定按钮 -->
          <el-button size="small" type="primary" :class="[theme]" @click="getAddFrequencyLimit"
                     v-if="deletefrequencyLimitDowm">确定
          </el-button>
          <!-- 删除模式：批量删除按钮 -->
          <el-button size="small" type="primary" :class="[theme]" @click="batchDeletefrequencyLimit2"
                     v-else>批量删除
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 接通限频 Tab 组件脚本部分
 *
 * 引入的 API 接口：
 * - deptParam：查询接通限频记录
 * - AddFrequencyLimit：添加限频规则
 * - deleteBatch：批量删除限频规则
 */
import {
  deptParam,
  AddFrequencyLimit,
  deleteBatch
} from '../../../api/dijia.js';

export default {
  name: 'DjFrequencyLimitTab',

  /**
   * 【Props 接收的参数】
   * - theme：主题颜色样式类名
   */
  props: {
    theme: { type: String, default: '' },
  },

  data() {
    return {
      // ========== 查询相关 ==========
      loading: false,           // 表格加载状态
      multipleSelection: [],    // 多选行数据
      query15: {                // 查询参数
        userId: localStorage.getItem('user'),
        phone: '',              // 手机号
        type: '',               // 类型筛选（AM=添加，D=删除）
        pageIndex: 1,           // 当前页码
        pageSize: 10,           // 每页条数
      },
      tableData15: [],          // 限频记录列表
      pageTotal15: 0,           // 总条数

      // ========== 弹窗相关 ==========
      deletefrequencyLimitDowm: false,  // 控制弹窗模式（true=导入模式，false=删除模式）
      frequencyLimitVisible: false,     // 弹窗是否显示
      frequencyLimitForm: {             // 弹窗表单
        userId: localStorage.getItem('user'),
        callNum: '',            // 限频次数
        phones: '',             // 号码（一行一个）
      },

      // ========== 筛选选项 ==========
      susList: [                // 状态筛选选项
        { value: null, label: '全部' },
        { value: true, label: '成功' },
        { value: false, label: '失败' }
      ],
      typeList: [               // 类型筛选选项
        { value: null, label: '全部' },
        { value: 'AM', label: '添加' },
        { value: 'D', label: '删除' }
      ],
    };
  },

  /**
   * 组件创建时查询限频记录
   */
  created() {
    this.getdeptParam();
  },

  methods: {
    /**
     * handleSelectionChange - 多选变化回调
     * @param {Array} val - 选中的行数据
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**
     * getdeptParam - 查询接通限频记录列表
     */
    getdeptParam() {
      deptParam(this.query15).then(res => {
        if (res?.code === 200) {
          this.tableData15 = res.data.list;
          this.pageTotal15 = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * getImport - 打开导入号码弹窗（导入模式）
     */
    getImport() {
      this.frequencyLimitVisible = true;
      this.deletefrequencyLimitDowm = true;
      this.frequencyLimitForm.callNum = '';
      this.frequencyLimitForm.phones = '';
    },

    /**
     * getAddFrequencyLimit - 提交导入号码（添加限频规则）
     */
    getAddFrequencyLimit() {
      AddFrequencyLimit(this.frequencyLimitForm).then(res => {
        if (res?.code === 200) {
          this.$message.success(res.data);
          this.frequencyLimitVisible = false;
          this.frequencyLimitForm.callNum = '';
          this.frequencyLimitForm.phones = '';
          this.getdeptParam();
        } else {
          this.$message.error(res.message);
        }
      });
    },

    /**
     * closefrequencyLimitDialog - 关闭弹窗并重置
     */
    closefrequencyLimitDialog() {
      this.frequencyLimitVisible = false;
      this.frequencyLimitForm.callNum = '';
      this.frequencyLimitForm.phones = '';
      this.deletefrequencyLimitDowm = false;
    },

    /**
     * showBatchDeletefrequency - 打开批量删除弹窗（删除模式）
     */
    showBatchDeletefrequency() {
      this.frequencyLimitVisible = true;
      this.deletefrequencyLimitDowm = false;
    },

    /**
     * batchDeletefrequencyLimit2 - 批量删除限频规则（通过输入号码）
     */
    batchDeletefrequencyLimit2() {
      this.$confirm('是否要删除此号码的拨打频次？', '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '不删除',
        closeOnClickModal: false
      }).then(() => {
        let data = { phones: this.frequencyLimitForm.phones };
        deleteBatch(data).then(res => {
          if (res?.code === 200) {
            this.$message.success(res.data);
            this.frequencyLimitVisible = false;
            this.deletefrequencyLimitDowm = false;
            this.getdeptParam();
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {});
    },

    /**
     * batchDeletefrequencyLimit - 单个删除限频规则（通过行数据）
     * @param {Object} row - 要删除的行数据
     */
    batchDeletefrequencyLimit(row) {
      this.$confirm('是否要删除此号码的拨打频次？', '提示', {
        type: 'warning',
        confirmButtonText: '删除',
        cancelButtonText: '不删除',
        closeOnClickModal: false
      }).then(() => {
        let data = { phones: row.phone };
        deleteBatch(data).then(res => {
          if (res?.code === 200) {
            this.$message.success(res.data);
            this.getdeptParam();
          } else {
            this.$message.error(res.message);
          }
        });
      }).catch(() => {});
    },

    /**
     * handlePageChange - 翻页回调
     * @param {number} val - 新的页码
     */
    handlePageChange(val) {
      this.query15.pageIndex = val;
      this.getdeptParam();
    },

    /**
     * handleSizeChange - 每页条数变化回调
     * @param {number} val - 新的每页条数
     */
    handleSizeChange(val) {
      this.query15.pageSize = val;
      this.query15.pageIndex = 1;
      this.getdeptParam();
    },
  }
};
</script>

<style scoped>
@import './tab-styles.css';
</style>
